<template>
  <div
    v-if="items.length > 1"
    :style="`border-bottom: ${theme.page_sidebar_filter_border_bottom_color} 1px solid`"
    class="storefront-sidebar-filters-container mb-0 pb-0"
  >
    <div class="storefront-sidebar-filters-title" @click="collapse">
      <h6 class="row m-0 align-items-center mb-0">
        <div style="width: 32px">
          <SidebarPreOrderIcon
            v-if="icon == 'price'"
            class=""
            :fill="theme.page_sidebar_icon_color"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
        </div>
        <span :style="`color: ${theme.page_sidebar_text_color}`">{{ title }}</span>
        <i :style="`color: ${theme.page_sidebar_text_color}`" :class="`fa fas fa-angle-${collapsed ? 'up' : 'down'} ml-auto`" />
      </h6>
    </div>
    <b-collapse class="storefront-sidebar-filters" :visible="!collapsed">
      <ul class="nav flex-column">
        <li v-for="(item, i) in items" :key="i" :style="filterItemStyle(item)" class="nav-item">
          <SelectBox
            :label="item.label"
            :selected-color="theme.page_sidebar_filter_item_selected_text_color"
            :not-selected-color="theme.page_sidebar_filter_item_text_color"
            :selected="item.selected"
            @on-selected="onSelect(item)"
          />
          <ul v-if="item.subItems && item.subItems.length > 0" class="nav flex-column ml-4">
            <li v-for="(subItem, si) in item.subItems" :key="si" :style="filterItemStyle(subItem)" :class="`nav-item`">
              <SelectBox
                :key="si"
                :label="subItem.label"
                :selected-color="theme.page_sidebar_filter_item_selected_text_color"
                :not-selected-color="theme.page_sidebar_filter_item_text_color"
                :selected="subItem.selected"
                @on-selected="onSubItemSelect(subItem)"
              />
            </li>
          </ul>
        </li>
      </ul>
    </b-collapse>
  </div>
</template>
<script>
import SidebarPreOrderIcon from "@/components/common/icons/SidebarPreOrderIcon.vue";
import SelectBox from "@/components/common/SelectBox.vue";
import BCollapse from "@/components/base/BCollapse.vue";

export default {
  components: {
    SelectBox,
    SidebarPreOrderIcon,
    BCollapse,
  },
  props: {
    title: { type: String, required: true },
    icon: { type: String },
    items: { type: [Object, Array], required: true },
    theme: { type: Object },
    category: { type: String },
    mutliSelect: { type: Boolean, default: false },
  },
  emits: ["selected", "sub-item-selected"],
  data() {
    return {
      collapsed: false,
      selected: [],
      filtered: false,
    };
  },
  computed: {},
  methods: {
    collapse() {
      this.collapsed = !this.collapsed;
    },
    filterItemStyle(item) {
      if (item.selected) {
        return {
          color: this.theme.page_sidebar_filter_item_color,
        };
      }
      return {
        color: this.theme.page_sidebar_filter_item_color,
      };
    },
    onSelect(item) {
      this.$emit("selected", item);
    },

    onSubItemSelect(subItem) {
      this.$emit("sub-item-selected", subItem);
    },
  },
};
</script>
